import { OptionType } from 'components';
import { initUtilisateur, Perimetre } from 'core/models';
import { createContext, useContext, useState } from 'react';

const UserPerimetreContext = createContext<any>({
    perimetre: [],
    setPerimetre: () => {},
    sante: true,
    setSante: () => {},
    prevoyance: true,
    setPrevoyance: () => {},
    colleges: true,
    setColleges: () => {},
    selectedColleges: [],
    setSelectedColleges: () => {},
    souscrips: [],
    setSouscrips: () => {},
    selectedSouscrips: [],
    setSelectedSouscrips: () => {},
    isLoadingSouscrips: [],
    setIsLoadingSouscrips: () => {},
    isLoadingColleges: [],
    setIsLoadingColleges: () => {},
    isLoadingPerimetre: [],
    setLoadingPerimetre: () => {},
    isUpdatingData: '',
    setIsUpdatingData: () => {},
    excludeVIP: false,
    setExcludeVIP: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function UserPerimetreProvider({ children }: Props) {
    const utilisateur = initUtilisateur();
    const [perimetre, setPerimetre] = useState<Perimetre[]>([]);
    const [sante, setSante] = useState(utilisateur.perimetre.risques.sante);
    const [prevoyance, setPrevoyance] = useState(utilisateur.perimetre.risques.prevoyance);
    const [colleges, setColleges] = useState<OptionType[]>(utilisateur.perimetre.colleges);
    const [selectedColleges, setSelectedColleges] = useState<OptionType[]>();
    const [souscrips, setSouscrips] = useState<OptionType[]>(utilisateur.perimetre.souscripteurs);
    const [selectedSouscrips, setSelectedSouscrips] = useState<OptionType[]>([]);
    const [isLoadingSouscrips, setIsLoadingSouscrips] = useState(false);
    const [isLoadingColleges, setIsLoadingColleges] = useState(false);
    const [isLoadingPerimetre, setLoadingPerimetre] = useState(false);
    const [hasPerimetreErreur, setHasPerimetreErreur] = useState(false);
    const [isUpdatingData, setIsUpdatingData] = useState<boolean>(false);
    const [excludeVIP, setExcludeVIP] = useState<boolean>(utilisateur.perimetre.excludeVIP); 

    return (
        <UserPerimetreContext.Provider
            value={{
                perimetre,
                setPerimetre,
                sante,
                setSante,
                colleges,
                setColleges,
                selectedColleges,
                setSelectedColleges,
                souscrips,
                setSouscrips,
                selectedSouscrips,
                setSelectedSouscrips,
                isLoadingSouscrips,
                setIsLoadingSouscrips,
                isLoadingColleges,
                setIsLoadingColleges,
                prevoyance,
                setPrevoyance,
                isLoadingPerimetre,
                setLoadingPerimetre,
                hasPerimetreErreur,
                setHasPerimetreErreur,
                isUpdatingData,
                setIsUpdatingData,
                excludeVIP,
                setExcludeVIP
            }}
        >
            {children}
        </UserPerimetreContext.Provider>
    );
}

export const useUserPerimetreContext = () => useContext(UserPerimetreContext);
